<!-- src/App.vue -->
<template>
  <v-app>
    <v-app-bar color="background" flat class="px-4" elevation="0">
      <div class="d-flex align-center">
        <v-icon icon="mdi-dumbbell" color="primary" size="large" class="mr-2"></v-icon>
        <span class="text-h6 font-weight-bold">HaltéroTrack</span>
      </div>
      <v-spacer></v-spacer>
      
      <div v-if="currentUser" class="d-flex align-center">
        <v-chip
          class="mr-4"
          variant="outlined"
          color="primary"
          prepend-icon="mdi-account"
        >
          {{ currentUser.displayName }}
        </v-chip>
      </div>
    </v-app-bar>
    
    <v-main class="bg-background">
      <v-container fluid class="fill-height pa-0">
        <v-row no-gutters>
          <v-col cols="12" class="pa-4">
            <router-view />
          </v-col>
        </v-row>
      </v-container>
    </v-main>
    
    <v-footer app class="bg-background text-center text-caption py-4" elevation="0">
      <div class="text-secondary">© {{ new Date().getFullYear() }} Application d'Évaluation en Haltérophilie</div>
    </v-footer>
  </v-app>
</template>

<script>
import { computed } from 'vue';
import { useStore } from 'vuex';

export default {
  name: 'App',
  setup() {
    const store = useStore();
    
    // Obtenir l'utilisateur actuel du store Vuex
    const currentUser = computed(() => store.getters.currentUser);
    
    return {
      currentUser
    };
  }
}
</script>

<style>
/* Styles globaux pour toute l'application */
html, body {
  overflow-x: hidden;
}

/* Personnalisation de l'apparence des scrollbars pour le thème sombre */
::-webkit-scrollbar {
  width: 10px;
  height: 10px;
}

::-webkit-scrollbar-track {
  background: rgba(255, 255, 255, 0.1);
  border-radius: 10px;
}

::-webkit-scrollbar-thumb {
  background: rgba(255, 255, 255, 0.2);
  border-radius: 10px;
}

::-webkit-scrollbar-thumb:hover {
  background: rgba(255, 255, 255, 0.3);
}

/* Animations et transitions */
.v-enter-active,
.v-leave-active {
  transition: opacity 0.3s ease;
}

.v-enter-from,
.v-leave-to {
  opacity: 0;
}

/* Styles pour les cartes modernes avec bordures légèrement arrondies */
.v-card {
  border-radius: 16px;
  overflow: hidden;
  transition: transform 0.3s, box-shadow 0.3s;
}

.v-card:hover {
  transform: translateY(-5px);
  box-shadow: 0 8px 16px rgba(0, 0, 0, 0.2);
}

/* Style pour les boutons hexagonaux */
.hex-button {
  position: relative;
  clip-path: polygon(25% 0%, 75% 0%, 100% 50%, 75% 100%, 25% 100%, 0% 50%);
  transition: all 0.3s;
}

.hex-button:hover {
  transform: scale(1.05);
}
/* Corrections pour mobile */
@media (max-width: 600px) {
  .v-row {
    max-width: 100% !important;
  }
  .v-row.v-row--no-gutters > .v-col, .v-row.v-row--no-gutters > [class*=v-col-] {
      padding: 0 !important;
  }
  .v-card-title + .v-card-text, .v-card-title + .v-card-actions {
      padding-top: 0 !important;
  }
  .v-container {
    padding: 8px !important; /* Réduire le padding sur mobile */
  }
  
  .v-app-bar .text-h6 {
    font-size: 1.1rem !important; /* Réduire la taille du titre dans la barre d'app */
  }
  
  .v-footer {
    padding: 8px 0 !important;
    height: auto !important;
  }
  
  /* Désactiver l'effet de survol qui peut causer des problèmes sur mobile */
  .v-card:hover {
    transform: none !important;
    box-shadow: none !important;
  }
}
/* Styles globaux pour les très petits écrans */
@media (max-width: 490px) {
  /* Forcer la largeur du contenu à ne pas dépasser la largeur de l'écran */
  body, html, .v-application, .v-application__wrap {
    max-width: 100vw !important;
    overflow-x: hidden !important;
  }
  
  /* Réduire les marges et paddings sur tous les composants Vuetify */
  .v-container {
    padding: 4px !important;
  }
  
  .v-col {
    padding: 4px !important;
  }
  
  .v-row {
    margin: 0 !important;
  }
  
  /* Réduire la taille des textes */
  .text-h4 {
    font-size: 1.4rem !important;
    line-height: 1.4 !important;
  }
  
  .text-h6 {
    font-size: 1rem !important;
    line-height: 1.4 !important;
  }
  
  /* Adapter les boutons */
  .v-btn {
    padding: 0 16px !important;
  }
}
</style>